__turbopack_context__.v({
  "disc": "FirstRunSun-module__4cP6pq__disc",
  "halo": "FirstRunSun-module__4cP6pq__halo",
  "shade": "FirstRunSun-module__4cP6pq__shade",
  "sun": "FirstRunSun-module__4cP6pq__sun",
  "surface": "FirstRunSun-module__4cP6pq__surface",
  "turn": "FirstRunSun-module__4cP6pq__turn",
});
